import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import "./HamburgerMenu.css";

interface HamburgerMenuButtonProps {
  onClick: () => void;
}
const HamburgerMenuButton = ({ onClick }: HamburgerMenuButtonProps) => {
  return (
    <>
      <button className="hamburger-button-icon" onClick={onClick}>
        <FontAwesomeIcon icon={faBars} style={{ color: "var(--green-500)" }} />
      </button>
    </>
  );
};

export default HamburgerMenuButton;
